import { render, staticRenderFns } from "./productType__form.vue?vue&type=template&id=33da6e12"
import script from "./productType__form.vue?vue&type=script&lang=js"
export * from "./productType__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports